import * as semver from 'semver'

export const hasWebViewHeader = (appVersion?: string): boolean => {
  if (!appVersion) {
    return false
  }

  const parsedAppVersion = semver.coerce(appVersion)

  return (parsedAppVersion && semver.gte(parsedAppVersion, '14.11.0')) ?? false
}
